<h2 class="display-4">
  I goods center
</h2>
<router-outlet></router-outlet>
